// extracted by mini-css-extract-plugin
export default {"table":"DataTable_table__YFLVH","inputContainer":"DataTable_inputContainer__h8Qll","subTable":"DataTable_subTable__rIo4x"};